import React, { createContext, useContext, useEffect, useState } from "react";
import { AuthContextValue, ContextProps, User } from "../types";
import axios from "axios";
import { fetchAuthSession, getCurrentUser } from "aws-amplify/auth";

const AuthContext = createContext<AuthContextValue>({
    user: undefined,
    setUser: () => {},
    logout: () => {}
});

const AuthContextProvider: React.FC<ContextProps> = ({ children }) => {
    const [loading, setLoading] = useState<boolean>(true);
    const [user, setUser] = useState<User | undefined>(undefined);
    const logout = async () => {
        console.log("logging user out");
        try {
            //   await signOut();
            setUser(undefined);
            sessionStorage.clear();
            //   delete axios.defaults.headers.common["Authorization"];
            //   toast.warn("Logged Out");
        } catch (error) {
            console.log("error signing out: ", error);
        }
    };
    const value: AuthContextValue = {
        user,
        setUser,
        logout
    };

    const validateToken = async () => {
        if (import.meta.env.VITE_ENV === "development") {
            setUser({
                id: "1234",
                name: "Shantanu Tripathi",
                username: "developer",
                email: "developerasdasds@gmail.com",
                isLoggedIn: true,
                roles: ["superuser"]
            });
            axios.defaults.headers.common["Access-token"] = "developer";
            axios.defaults.baseURL = import.meta.env.VITE_BACKEND_BASE_URL;

            // const url2 = import.meta.env.VITE_BACKEND_BASE_URL + "/get-api-token";
            // const response = await axios.get(url2);
            // axios.defaults.headers.common["Api-Access-Token"] = response.data.token;
            //   toast.success("Login Successful");
            setLoading(false);
        } else {
            try {
                const { idToken, accessToken } = (await fetchAuthSession({ forceRefresh: true })).tokens ?? {};
                const currentUser = await getCurrentUser();
                const { username, userId } = currentUser;
                // console.log(currentUser);
                console.log(idToken, accessToken);
                if (!idToken || !accessToken) throw new Error("User Session expired");
                axios.defaults.baseURL = import.meta.env.VITE_BACKEND_BASE_URL;
                // const isUserAuthorized = await axios.post("https://smartlearn.drake-ltim.com/api/auth/validate-token");
                // console.log(isUserAuthorized);

                // const url2 = import.meta.env.VITE_BACKEND_BASE_URL + "/get-api-token";
                // const response = await axios.get(url2);
                // axios.defaults.headers.common["Api-Access-Token"] = response.data.token;

                // console.log("decoded", decoded);

                setUser({
                    id: userId,
                    username: username,
                    isLoggedIn: true,
                    // @ts-ignore
                    name: idToken.payload?.name,
                    // @ts-ignore
                    email: idToken.payload?.email,
                    // @ts-ignore
                    roles: idToken.payload["cognito:groups"]
                });
                setLoading(false);
            } catch (err) {
                console.log(err);
                setLoading(false);
            }
        }
    };

    console.log("app ready", !loading);

    useEffect(() => {
        validateToken();
        axios.interceptors.response.use(
            function (response) {
                // Any status code that lie within the range of 2xx cause this function to trigger
                // Do something with response data
                return response;
            },
            function (error) {
                // Any status codes that falls outside the range of 2xx cause this function to trigger
                // Do something with response error
                if (error.message.includes("401")) {
                    logout();
                }
                return Promise.reject(error);
            }
        );
    }, []);

    if (!loading) {
        return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
    } else {
        return (
            <div className="flex h-screen w-screen items-center justify-center">
                <span>Loading...</span>
            </div>
        );
    }
};

export const useAuth = (): AuthContextValue => {
    return useContext(AuthContext);
};

export default AuthContextProvider;
